export default __webpack_public_path__ + "static/exchange-0b175af449b3bdd990abef8e3b07e4a5.png";